import React from 'react';
import { formatCompact, formatCompactTonnes } from '../utils/formatNumber';

const PurchasesGrid = ({ data, purchaseMetrics }) => {
  return (
    <div className="grid grid-cols-3 gap-4 mb-6">
      {/* Purchases This Week */}
      <div className="bg-[#252836] rounded-xl p-6 border border-gray-700">
        <div className="text-sm text-gray-400 mb-2">PURCHASES THIS WEEK</div>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-bold">{formatCompact(purchaseMetrics.thisWeekPurchases.value, { currency: 'USD' })}</span>
          <span className="text-gray-400">{formatCompactTonnes(purchaseMetrics.thisWeekPurchases.weight)} tonnes</span>
        </div>
      </div>

      {/* Purchases This Month */}
      <div className="bg-[#252836] rounded-xl p-6 border border-gray-700">
        <div className="text-sm text-gray-400 mb-2">PURCHASES THIS MONTH</div>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-bold">{formatCompact(purchaseMetrics.thisMonthPurchases.value, { currency: 'USD' })}</span>
          <span className="text-gray-400">{formatCompactTonnes(purchaseMetrics.thisMonthPurchases.weight)} tonnes</span>
        </div>
      </div>

      {/* Purchases YTD */}
      <div className="bg-[#252836] rounded-xl p-6 border border-gray-700">
        <div className="text-sm text-gray-400 mb-2">PURCHASES YTD</div>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-bold">{formatCompact(purchaseMetrics.ytdPurchases.value, { currency: 'USD' })}</span>
          <span className="text-gray-400">{formatCompactTonnes(purchaseMetrics.ytdPurchases.weight)} tonnes</span>
        </div>
      </div>
    </div>
  );
};

export default PurchasesGrid;